import Resource from '@/api/resources/Resource'

class SubportionService extends Resource {
    async getAssaySummaryForCase(labId, casId) {
        const response = await this.axios.get(`/diagnosis/laboratories/${labId}/cases/${casId}/samples/portions/subportions/summary`)
        return response.data
    }

    async getAssaysForCase(labId, casId) {
        const response = await this.axios.get(`/diagnosis/laboratories/${labId}/cases/${casId}/samples/portions/subportions`)
        return response.data
    }
    async getAssaysForSample(labId, casId, samId) {
        const response = await this.axios.get(`/diagnosis/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/subportions`)
        return response.data
    }

    async getAssaySummaryForSample(labId, casId, samId) {
        const response = await this.axios.get(`/diagnosis/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/subportions/summary`)
        return response.data
    }

    async searchSubportionByLabel(subportionLabel) {
        const params = { subportionLabel }
        const response = await this.axios.get(`/diagnosis/laboratories/cases/samples/portions/subportions/searchBySubportionLabel`, { params })
        return response.data
    }
}

export default new SubportionService()
